import { scrollToTop } from "@/helpers/helpers";
import React, { useEffect, useState } from "react";

const ScrollTop: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    // Cleanup
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <>
   
      <div id="wrapper">
        <div className="scrollbar" id="style-8">
          <div className="force-overflow"></div>
        </div>
      </div>

      <a 
        id="button" 
        onClick={handleClick}
        className={isVisible ? 'show' : ''}
        href="#"
      >
        <i className="fa-solid fa-arrow-up-long fa-bounce"></i>
      </a>
    </>
  );
};

export default ScrollTop;
